module.exports = __webpack_public_path__ + "img/forwardburger.dd5afdfb.svg";